import React from 'react'
import { Grid, Row, Panel, Table, Button, Message } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'
import pathname from '../../constants/pathname'

export default function ProgressIndicatorView({
  onSelectConnection = () => {},
  showConnectionButton,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const { schema } = props
  // console.log('OutcomeResultView', schema)
  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Table
              isTree
              defaultExpandAllRows
              rowKey="id"
              cellBordered
              // height={400}
              autoHeight
              wordWrap
              data={schema?.values || []}
            >
              <Column width={500}>
                <HeaderCell>{schema.columnText1}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.label || rowData.expectedOutcome || rowData.indicatorName
                  }}
                </Cell>
              </Column>

              <Column width={120} align="center">
                <HeaderCell>{schema.columnText2}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (typeof rowData.indicatorType !== 'undefined') {
                      return (
                        <>
                          {schema.indicatorOptions.map((item) => {
                            if (item.value == rowData.indicatorType) {
                              return item.label
                            }
                          })}
                        </>
                      )
                    }
                  }}
                </Cell>
              </Column>

              <Column minWidth={250} width={250} flexGrow={1}>
                <HeaderCell>{schema.columnText3}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.indicatorType == 0) {
                      return <div dangerouslySetInnerHTML={{ __html: rowData.result }}></div>
                    } else {
                      // return <div>{`${rowData.result || ''} ${rowData.unit || ''}`}</div>
                      return <div>{`${rowData.indicatorResult || ''}`}</div>
                    }
                  }}
                </Cell>
              </Column>

              {showConnectionButton && (
                <Column width={150} align="center" fixed="right">
                  <HeaderCell></HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return (
                        <>
                          {rowData.indicatorType == 1 && (
                            <>
                              <TooltipButton
                                style={{ width: '100%' }}
                                icon="edit"
                                tooltip={`ระบุความเชื่อมโยงของยุทธศาสตร์การทำงาน`}
                                onClick={() => {
                                  // setIsShowConnection(true)
                                  onSelectConnection(rowData)
                                }}
                                // disabled={isLoading}
                              >
                                ความเชื่อมโยง
                              </TooltipButton>

                              <Message
                                showIcon
                                style={{ marginTop: 10 }}
                                type="warning"
                                description={
                                  <p>
                                    <a
                                      href="#"
                                      onClick={() => {
                                        window.location.href = `${pathname.proposal.projectManagement.intellectualProperty}`
                                        window.opener = null
                                      }}
                                    >
                                      กรุณากรอกรายละเอียดงานวิจัยและนวัตกรรมให้ครบถ้วน
                                    </a>
                                  </p>
                                }
                              />
                              {/* <TooltipButton
                                style={{ width: '100%', marginTop: 10 }}
                                icon="edit"
                                tooltip={`บันทึกข้อมูลงานวิจัยและนวัตกรรม`}
                                onClick={() => {
                                  // setIsShowConnection(true)
                                  // onSelectConnection(rowData)
                                  window.location.href = `${pathname.proposal.projectManagement.intellectualProperty}`
                                  window.opener = null
                                }}
                                disabled={isLoading || rowData.id.indexOf(newRowPrefixKey) != -1}
                              >
                                ข้อมูลงานวิจัยและนวัตกรรม
                              </TooltipButton> */}
                            </>
                          )}
                        </>
                      )
                    }}
                  </Cell>
                </Column>
              )}
            </Table>
          </Grid>
        </Panel>
      </Row>
    </div>
  )
}
